import { getProductTokens } from '@sirius-cybernetics-42/product-config'

import { ChainId, Token } from '../../sdk'

function toProductToken(chainId: ChainId, symbol: string) {
  const product = getProductTokens(chainId).find((entry) => entry.symbol === symbol)
  if (!product) {
    throw new Error(`Missing product token ${symbol} for chain ${chainId}`)
  }
  return product
}

const tdontProduct = toProductToken(ChainId.INFINITE_TESTNET, 'T-DONT')

export const TDONT = new Token(
  ChainId.INFINITE_TESTNET,
  tdontProduct.address,
  tdontProduct.decimals,
  tdontProduct.symbol,
  tdontProduct.name,
)
